import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import Dexie, { Table } from 'dexie'
import { Moment } from 'moment'
import { IInputFields } from 'pages/NGT/Reports/ReportsCRE/ReportsCRE'
import { MotivosBloqueioInterface } from 'services/NGT/RecordsSheet'

export type DateTime = Date | Moment | string

export interface IKeyValue<TValue> {
  key: number
  value: TValue
  checked?: boolean
  cdDocto?: string
}

export interface IReportsAcesssModel {
  id: number
  contrato: string
  fornecedor: string
  subcontratada: string
  empresa: string
  centro: string
  tipoContrato: boolean
  inicioValidade: DateTime
  fimValidade: DateTime
  status: string
  contratos: IKeyValue<string>[]
  fornecedores: IKeyValue<string>[]
  empresas: IKeyValue<string>[]
  centros: IKeyValue<string>[]
  perfil: number
  subFornecedores: IKeyValue<string>[]
  unidadeGestoraId: IOnChangeUnidadeGestora
}

export interface IReportsEffectiveModel {
  id: number
  isTipoTerceiros: boolean
  isTipoContrato: boolean
  relatorio: string
  tipo: string
  contrato: string
  fornecedor: string
  empresa: string
  centro: string
  subcontratada: string
  contratos: IKeyValue<string>[]
  fornecedores: IKeyValue<string>[]
  empresas: IKeyValue<string>[]
  centros: IKeyValue<string>[]
  subContratadas: IKeyValue<string>[]
  unidadeGestoraId: IOnChangeUnidadeGestora
  competenciaInicio?: DateTime
  competenciaFim?: DateTime
  flags: {
    todos: boolean
    validContraparte: boolean
    validAnalista: boolean
  }
}

export interface IReportsCurrentContratsModel {
  id: number
  matriculaContraparte: string
  nomeContraparte: string
  matriculaSubstituto: string
  nomeSubstituto: string
  nomeFornecedor: string
  nomeEmpresa: string
  nomeCentro: string
  nomeSubcontratada: string
  contratos: IKeyValue<string>[]
  dataVigencia: DateTime
  unidadeGestoraId: IOnChangeUnidadeGestora
  contrapartes: IKeyValue<string>[]
  tipoCres: IKeyValue<string>[]
  substitutos: IKeyValue<string>[]
  fornecedores: IKeyValue<string>[]
  empresas: IKeyValue<string>[]
  centros: IKeyValue<string>[]
  subcontratadas: IKeyValue<string>[]
  flags: {
    sazonal: boolean
    normal: boolean
    naoSeAplica: boolean
    semPreenchimento: boolean
    recorrente: boolean
    socio: boolean
    encerrado: boolean
  }
}

enum ITipoBloqueado {
  frBloqueadas = 0,
  comDesobramento = 1,
  bloqueadoParaPagamento = 2
}

export interface IReportsBlock {
  id: number
  fornecedor: string
  subcontratada: string
  centro: string
  contrato: string
  nomeEmpresa: string
  contratos: IKeyValue<string>[]
  empresas: IKeyValue<string>[]
  fornecedores: IKeyValue<string>[]
  tipoBloqueio: ITipoBloqueado
  subfornecedores: IKeyValue<string>[]
  centros: IKeyValue<string>[]
  inicioBloqueio?: DateTime
  fimBloqueio?: DateTime
  analistaId: number
  nmAnalista: string
  matricula: string
  unidadeGestoraId: IOnChangeUnidadeGestora
  motivo: number
  motivoBloqueioList: MotivosBloqueioInterface[],
  cdFolhaRegistroSRV?: string
  txDocumento?: string
  txReferencia?: string
}

export interface IReportsCreModel {
  id: number
  cdContrato: string
  fornecedor: string
  empresa: string
  centro: string
  subcontratado: string
  nmMatricula: string
  nmAnalista: string
  periodoEntradaInicio: DateTime
  periodoEntradaFim: DateTime
  competenciaInicio: DateTime
  competenciaFim: DateTime
  contratos: IKeyValue<string>[]
  fornecedores: IKeyValue<string>[]
  empresas: IKeyValue<string>[]
  centros: IKeyValue<string>[]
  subcontradatas: IKeyValue<string>[]
  unidadeGestoraId: IOnChangeUnidadeGestora
  flLiberado: string
  flPrescricao: string
  denuncia: string
}

class ReportsDatabase extends Dexie {
  currentContracts!: Table<IReportsCurrentContratsModel>
  access!: Table<IReportsAcesssModel>
  effectives!: Table<IReportsEffectiveModel>
  block!: Table<IReportsBlock>
  cre!: Table<IReportsCreModel>
  expandedCardsMovMensal!: Table<{ id: number }>

  constructor() {
    super('ReportsDatabase')
    this.version(1).stores({
      access: 'id',
      block: 'id',
      cre: 'id',
      currentContracts: 'id',
      effectives: 'id',
      expandedCardsMovMensal: 'id'
    })
  }
}

export const reportsDatabase = new ReportsDatabase()
